export default "__VITE_ASSET__ZvK0$4HX__"